import {
  FETCH_COUNTRY_SITES_SUCCESS,
  RESET_COUNTRY_SITE_SEARCH
} from "./constants";

const initialState = {
  data: [],
  state_count: null,
  site_count:  null
};

function siteCountrySearchReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_COUNTRY_SITES_SUCCESS: {
      const { data, state_count, site_count } = action;
      return {
        ...state,
        data,
        state_count,
        site_count
      };
    }
    case RESET_COUNTRY_SITE_SEARCH: {
      return {
        ...state,
        state_count: null,
        site_count:  null,
        data: []
      };
    }

    default:
      return state;
  }
}

export default siteCountrySearchReducer;
